/**
 * The Task Field IDs.
 */
export enum ClickUpTaskFieldId {
	userName = "cd323c14-5d95-4ab5-8736-400168cb2616",
	userMail = "f210eea2-bccf-4b33-be25-03831fd0619d",
	userCompanyId = "8a9dde52-ddd2-4574-858f-095fbb8ec849",
	userCompanyName = "5376a080-6137-4e83-a79b-2902f2bb5b8b"
}
